// features/client/client.dependencies.js

import apiCompany from "../../api";


export const loadDependencies = async () => {
  const [
    countriesRes,
    clientsRes,
  ] = await Promise.allSettled([
    apiCompany.getCountries(),
    apiCompany.getAllClients({ role: "CLIENT" }),
  ]);

  const extract = (res) =>
    res.status === "fulfilled"
      ? res.value?.data?.data || []
      : [];


  const clients = extract(clientsRes).map(client => ({
    ...client,
    client_name: `${client.first_name || ""} ${client.last_name || ""}`.trim()
  }));


  return {
    countries: extract(countriesRes),
    clients
  };
};